import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=66aee55b&scoped=true"
import script from "./InputRadio.ts?vue&type=script&lang=ts&external"
export * from "./InputRadio.ts?vue&type=script&lang=ts&external"
import style0 from "./InputRadio.scss?vue&type=style&index=0&id=66aee55b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aee55b",
  null
  
)

export default component.exports